import Reveal from 'stimulus-reveal-controller';

export default class extends Reveal {
  static targets = ['html', 'link', 'pdf', 'spreadsheet'];

  connect() {
    super.connect();
  }

  toggleByOpt(e) {
    const targetMap = {
      pdf: this.pdfTarget,
      link: this.linkTarget,
      html: this.htmlTarget,
      video: this.htmlTarget,
      spreadsheet: this.spreadsheetTarget,
    };

    const selectedTarget = targetMap[e.currentTarget.value];

    this.constructor.targets.forEach((name) => {
      this[`${name}Target`].classList.add(this.hiddenClass);
    });

    if (selectedTarget) {
      selectedTarget.classList.remove(this.hiddenClass);
    }
  }
}
